import { InjectionToken } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

/**
 * App-supplied hook for auth failures (HTTP 401/403) seen by the shell
 * {@link authInterceptor}.
 *
 * The shell deliberately does NOT decide what a 401/403 means for a given app
 * (redirect to a B2C login, route to an access-denied page, toast, …) — that is
 * portal-specific policy. When provided, the interceptor invokes {@link handle}
 * on each 401/403 and then RE-THROWS the original error (it never swallows it),
 * so downstream handlers and the call site keep their existing behaviour.
 *
 * Tied to PBI 1466 (dedicated Phoenix B2C app-registration / login-initiation):
 * the main portal supplies a handler that drives its existing 401/403 redirect
 * logic; the shell stays redirect-agnostic.
 */
export interface AuthErrorHandler {
  /** Called for each `HttpErrorResponse` with status 401 or 403. Must not swallow. */
  handle(error: HttpErrorResponse): void;
}

/**
 * Optional DI token for an {@link AuthErrorHandler}. If unprovided, the shell
 * {@link authInterceptor} performs NO special 401/403 handling (behaviour is
 * byte-identical to having no hook).
 */
export const AUTH_ERROR_HANDLER = new InjectionToken<AuthErrorHandler>(
  'AUTH_ERROR_HANDLER'
);
